/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { AdminClassifierService } from '../../services/admin/admin-classifier.service';
import { GlobalMessageService } from '../../services/global-message.service';

import { Constants, Language } from '../../global/constants';

import { ConfirmDialogComponent } from '../../global/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-admin-classifier',
  templateUrl: './admin-classifier.component.html'
})
export class AdminClassifierComponent implements OnInit {

  loadingPage: boolean = true;
  addClassifierDialogRef: BsModalRef;
  editTrainingDialogRef: BsModalRef;
  editPhraseDialogRef: BsModalRef;
  addStopwordDialogRef: BsModalRef;
  showStopwords: boolean = false;
  tab: string = 'training';
  classifiers: any[] = [];

  // dropdown state
  ddAccounts: any[] = [];
  ddClassifiers: any[] = [];
  currentAccount: any[] = [];
  currentClassifier: any[] = [];
  categories: any[] = [];
  currentCategory: any;
  currentLanguage: Language;
  currentCategoryConfig: any = {
    name: '',
    score: 0,
    probability: 0
  };

  // page data
  nbTraining: any[] = [];
  wordmap: any = {};
  nbStopwords: any[] = [];
  phraseTraining: any[] = [];

  // dialog data
  classifyAccounts: any[] = [];
  newClassifierAccount: any = null;
  newClassifierName: string = '';

  currentTraining: any = {
    id: null,
    training: '',
    category: '',
    exact: false,
    language: 'en'
  };

  newTrainingFlag: boolean = false;

  languageFilter: string = 'en';

  showWordmap: boolean = false;
  topWord: number = 0;
  topStopword: number = 0;

  accountDDSettings: any = {
    text: 'Account',
    enableSearchFilter: true,
    badgeShowLimit: 1,
    singleSelection: true,
    classes: 'font-size-sm'
  };

  classifierDDSettings: any = {
    text: 'Select Classifier',
    enableSearchFilter: true,
    badgeShowLimit: 1,
    singleSelection: true,
    classes: 'font-size-sm'
  };

  constructor(private modalService: BsModalService,
              private adminClassifierService: AdminClassifierService,
              private constants: Constants,
              private globalMessageService: GlobalMessageService) { }

  ngOnInit() {
    this.currentLanguage = this.constants.languages[0];
    this.initView();
  }

  changeAccount() {
    this.initState();
  }

  changeClassifier() {
    this.currentCategory = null;
    this.refreshView();
  }

  changeCategory() {
    this.refreshView();
  }

  changeLanguage() {
    this.refreshView();
  }

  addClassifier(dialog) {
    this.addClassifierDialogRef = this.modalService.show(dialog, {class: 'modal-md'});
  }

  saveClassifier() {
    this.addClassifierDialogRef.hide();
    this.adminClassifierService.newClassifier(this.newClassifierName, this.newClassifierAccount ? this.newClassifierAccount._id : null).subscribe(
      (result: any) => {
        this.classifiers.push(result);
        this.currentClassifier = [{id: result._id, itemName: result.name}];
        this.globalMessageService.message(`New classifier saved`);
        this.initState();
      },
      e => {
        console.log(e);
      }
    );
  }

  editNBTraining(dialog, training: any = null) {
    if (training) {
      this.newTrainingFlag = false;
      this.currentTraining.id = training.id;
      this.currentTraining.category = training.category;
      this.currentTraining.training = training.content;
      this.currentTraining.language = training.language;
    }
    else {
      this.newTrainingFlag = true;
      this.currentTraining.id = null;
      this.currentTraining.category = '';
      this.currentTraining.training = '';
      this.currentTraining.language = this.languageFilter;
    }

    this.editTrainingDialogRef = this.modalService.show(dialog, {class: 'modal-lg'});
  }

  saveTraining() {
    this.editTrainingDialogRef.hide();
    let model: any = {
      category: this.currentTraining.category,
      content: this.currentTraining.training,
      language: this.currentTraining.language,
      active: true
    };

    if (!this.currentTraining.id) {
      // new training
      this.adminClassifierService.addNBTraining(this.currentClassifier[0].id, model).subscribe(
        (result: any) => {
          // push new training
          this.classifiers.find(b => { return b._id == this.currentClassifier[0].id}).training.nb.training.push(result);
          this.refreshView();
          this.globalMessageService.message(`New training added`);
        },
        e => {
          console.log(e);
        }
      );
    }
    else {
      model.id = this.currentTraining.id;
      // edit training
      this.adminClassifierService.updateNBTraining(this.currentClassifier[0].id, this.currentTraining.id,  model).subscribe(
        (result: any) => {
          let bot = this.classifiers.find(b => { return b._id == this.currentClassifier[0].id});
          let t = bot.training.nb.training.find(nbt => { return nbt.id == this.currentTraining.id});
          t.content = model.content;
          t.language = model.language;
          this.refreshView();
          this.globalMessageService.message(`Training updated`);
        },
        e => {
          console.log(e);
        }
      );
    }
  }

  deleteNBTraining(training: any) {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Confirm you'd like to delete this training: "${training.content}"`,
        confirm: function() {
          me.adminClassifierService.deleteNBTraining(me.currentClassifier[0].id, training.id).subscribe(
            (result: any) => {
              me.globalMessageService.message('Training was deleted');
              me.initView();
            },
            e => {
              console.log(e);
            });
        }
      }
    }));
  }

  addNBStopword(dialog) {
    this.newTrainingFlag = true;
    this.currentTraining.training = '';
    this.currentTraining.language = this.languageFilter;

    this.addStopwordDialogRef = this.modalService.show(dialog, {class: 'modal-md'});
  }

  saveNBStopword() {
    this.addStopwordDialogRef.hide();
    let model: any = {
      word: this.currentTraining.training,
      language: this.currentTraining.language,
      active: true
    };

    this.adminClassifierService.addNBStopword(this.currentClassifier[0].id, model).subscribe(
      (result: any) => {
        // push new training
        this.classifiers.find(b => { return b._id == this.currentClassifier[0].id}).training.nb.stopword.push(result);
        this.refreshView();
        this.globalMessageService.message(`New stopword added`);
      },
      e => {
        console.log(e);
      }
    );
  }

  addNBStopwordInline(word: any) {
    let model: any = {
      word: word.word,
      language: this.currentTraining.language,
      active: true
    };

    this.adminClassifierService.addNBStopword(this.currentClassifier[0].id, model).subscribe(
      (result: any) => {
        // push new training
        this.classifiers.find(b => { return b._id == this.currentClassifier[0].id}).training.nb.stopword.push(result);
        this.refreshView();
        this.globalMessageService.message(`New stopword added`);
      },
      e => {
        console.log(e);
      }
    );
  }

  deleteNBStopwordInline(word: any) {
    let classifier = this.classifiers.find(b => { return b._id == this.currentClassifier[0].id});
    let sw = classifier.training.nb.stopword.find(sw => { return sw.word == word.word});
    this.adminClassifierService.deleteNBStopword(this.currentClassifier[0].id, sw.id).subscribe(
      (result: any) => {
        this.initView();
        this.globalMessageService.message(`Stopword deleted`);
      },
      e => {
        console.log(e);
      }
    );
  }

  saveCategoryConfig() {
    let categories = this.classifiers.find(b => { return b._id == this.currentClassifier[0].id}).training.nb.category;
    let selectedIndex = categories.findIndex(c => c.name == this.currentCategory);

    // set new values on the category being changed, saving the old name for remapping in the back-end
    categories[selectedIndex].old_name = categories[selectedIndex].name;
    categories[selectedIndex].name = this.currentCategoryConfig.name;
    categories[selectedIndex].s = parseFloat(this.currentCategoryConfig.score);
    categories[selectedIndex].p = parseFloat(this.currentCategoryConfig.probability);

    // sends all categories. uadmin only so not a lot of chance of colission
    this.adminClassifierService.updateNBCategoryConfig(this.currentClassifier[0].id, categories).subscribe(
      (result: any) => {
        this.globalMessageService.message(`Config saved`);
        this.refreshView();
      },
      e => {
        console.log(e);
      }
    );
  }

  editPhraseTraining(dialog, training: any = null) {
    if (training) {
      this.newTrainingFlag = false;
      this.currentTraining.id = training.id;
      this.currentTraining.category = training.category;
      this.currentTraining.training = training.content;
      this.currentTraining.exact = training.exact;
      this.currentTraining.language = training.language;
    }
    else {
      this.newTrainingFlag = true;
      this.currentTraining.id = null;
      this.currentTraining.category = '';
      this.currentTraining.training = '';
      this.currentTraining.exact = false;
      this.currentTraining.language = this.languageFilter;
    }

    this.editPhraseDialogRef = this.modalService.show(dialog, {class: 'modal-md'});
  }

  savePhraseTraining() {
    this.editPhraseDialogRef.hide();
    let model: any = {
      category: this.currentTraining.category,
      content: this.currentTraining.training,
      language: this.currentTraining.language,
      exact: this.currentTraining.exact,
      active: true
    };

    if (!this.currentTraining.id) {
      // new training
      this.adminClassifierService.addPhraseTraining(this.currentClassifier[0].id, model).subscribe(
        (result: any) => {
          // push new training
          this.classifiers.find(b => { return b._id == this.currentClassifier[0].id}).training.phrase.training.push(result);
          this.refreshView();
          this.globalMessageService.message(`New phrase training added`);
        },
        e => {
          console.log(e);
        }
      );
    }
    else {
      model.id = this.currentTraining.id;
      // edit training
      this.adminClassifierService.updatePhraseTraining(this.currentClassifier[0].id, this.currentTraining.id,  model).subscribe(
        (result: any) => {
          let bot = this.classifiers.find(b => { return b._id == this.currentClassifier[0].id});
          let t = bot.training.phrase.training.find(pt => { return pt.id == this.currentTraining.id});
          t.content = model.content;
          t.language = model.language;
          t.exact = model.exact;
          this.refreshView();
          this.globalMessageService.message(`Phrase training updated`);
        },
        e => {
          console.log(e);
        }
      );
    }
  }

  deletePhraseTraining(training: any) {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: `Confirm you'd like to delete this training: "${training.content}"`,
        confirm: function() {
          me.adminClassifierService.deletePhraseTraining(me.currentClassifier[0].id, training.id).subscribe(
            (result: any) => {
              me.globalMessageService.message('Phrase training was deleted');
              me.initView();
            },
            e => {
              console.log(e);
            });
        }
      }
    }));
  }

  getWidth(count, total) {
    return (count/total*100).toString() + '%';
  }

  clean() {
    this.currentTraining.training = this.currentTraining.training
                                  .replace(/['’]/g, '')
                                  .replace(/[@.,-\/#!?$%\^&\*;:{}=\-_`~()\<\>"|0-9]/g, ' ')
                                  .replace(/\s{2,}/g, ' ')
                                  .trim()
                                  .toLowerCase();
  }

  private initView() {
    this.loadingPage = true;
    Observable.forkJoin(
      this.adminClassifierService.getClassifiers(),
      this.adminClassifierService.getClassifierAccounts()
    ).subscribe(
      (results: any) => {
        this.classifiers = results[0];
        this.classifyAccounts = results[1];
        this.ddAccounts = [{id: 'all', itemName:'All Accounts'}];
        this.classifyAccounts.forEach(ba => {
          this.ddAccounts.push({id: ba._id, itemName: ba.name});
        });
        this.currentAccount = [this.ddAccounts.find(dda => {return dda.id == 'all'})];
        this.initState();
        this.loadingPage = false;
      },
      e => {
        console.log(e);
      }
    );
  }

  /**
   * Initialize state of controls and local meta data. Done when the page loads or a different account is selected
   */
  private initState(classifierId: string = null) {
    this.ddClassifiers = [];
    if (this.currentAccount[0].id == 'all') {
      // for "all" accounts, find bots with account_id == null
      this.classifiers.forEach(bot => {
        if (!bot.account_id) {
          this.ddClassifiers.push({ id: bot._id, itemName: bot.name });
        }
      });
    }
    else {
      // otherwise match to account_id
      this.classifiers.forEach(bot => {
        if (bot.account_id == this.currentAccount[0].id) {
          this.ddClassifiers.push({ id: bot._id, itemName: bot.name });
        }
      });
    }

    this.refreshView();
  }

  private refreshView() {
    this.categories = [];
    this.nbTraining = [];
    this.phraseTraining = [];
    this.nbStopwords = [];
    this.wordmap = {};
    this.showStopwords = false;

    // If there is a bot selected, set up training in local meta data and show detail
    if (this.currentClassifier.length > 0 && this.currentClassifier[0].id) {

      let bot = this.classifiers.find(b => { return b._id == this.currentClassifier[0].id});

      // set up categories for this bot
      bot.training.nb.category.forEach(cat => {
        this.categories.push(cat.name);
      });

      // set up training docs for this bot + category
      if (this.currentCategory) {
        bot.training.nb.training.forEach(doc => {
          if (doc.category == this.currentCategory && doc.language == this.languageFilter) {
            this.nbTraining.push(doc);
          }
        });
        bot.training.phrase.training.forEach(doc => {
          if (doc.category == this.currentCategory && doc.language == this.languageFilter) {
            this.phraseTraining.push(doc);
          }
        });
        this.updateTermCounts();
        this.refreshCategoryConfig(bot.training.nb.category);
      }

      this.showStopwords = true;
      bot.training.nb.stopword.forEach(doc => {
        if (doc.language == this.languageFilter) {
          this.nbStopwords.push(doc);
        }
      });
    }

    this.sort();
  }

  private updateTermCounts() {
    this.topWord = 0;
    this.topStopword = 0;
    // get a wordmap for the category
    this.adminClassifierService.getWordmap(this.currentClassifier[0].id, this.currentCategory, this.languageFilter).subscribe(
      (result: any) => {
        this.wordmap = result;
        this.wordmap.words.forEach((wm) => {
          if (wm.stop_word && wm.count > this.topStopword) {
            this.topStopword = wm.count;
          }
          else if (!wm.stop_word && wm.count > this.topWord) {
            this.topWord = wm.count;
          }
        });
      },
      e => {
        console.log(e);
      }
    );
  }

  private refreshCategoryConfig(categories) {
    let selectedCategory = categories.find(c => c.name == this.currentCategory);
    this.currentCategoryConfig.name = selectedCategory.name;
    this.currentCategoryConfig.probability = selectedCategory.p ? selectedCategory.p : 0;
    this.currentCategoryConfig.score = selectedCategory.s ? selectedCategory.s : 0;
  }

  private sort() {
    this.nbTraining.sort((a, b) => {
      if (a.content.length > b.content.length) {
        return 1;
      }
      else {
        return -1;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/admin-classifier/admin-classifier.component.ts